<!-- Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. -->

<div class="chip-container {{ themeType }}">
	<div
		class="chip {{ chip.styleClass }}"
		*ngFor="let chip of dayChips | async"
		[ngClass]="{
			'chip-on': chip.isOn,
			'chip-selected': chip.isSelected,
			'chip-disabled': disabled || chip.disabled,
		}"
		(click)="clickChip(chip)"
	>
		{{ chip.label }}
	</div>
</div>
